import React, { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SideButton } from "./LayoutStyles";

const RightSideBarButtons = ({ handleRightDrawerToggle }) => {
  const { t } = useTranslation();

  return (
    <SideButton color="secondary" variant="contained" onClick={handleRightDrawerToggle}>
      {t("Summary")}
    </SideButton>
  );
};

RightSideBarButtons.propTypes = {
  handleRightDrawerToggle: PropTypes.func.isRequired
};

export default memo(RightSideBarButtons);
